var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-1fef4a42"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "container" };
var _hoisted_2 = {
    key: 0,
    class: "mt-7 category inline-flex"
};
var _hoisted_3 = { class: "inline-flex items-center" };
var _hoisted_4 = { class: "text-lg text-medium" };
var _hoisted_5 = {
    key: 1,
    class: "py-4"
};
var _hoisted_6 = { class: "grid grid-cols-12 gap-x-8 gap-y-6 w-full" };
var _hoisted_7 = {
    key: 2,
    class: "inline-flex mt-4"
};
var _hoisted_8 = { class: "text-lg text-medium" };
var _hoisted_9 = {
    key: 3,
    class: "py-4"
};
var _hoisted_10 = { class: "grid grid-cols-12 gap-y-4 w-full sm:gap-x-8 md:gap-y-6" };
var _hoisted_11 = {
    key: 1,
    class: "mt-10 text-lg courses-empty"
};
import cardCourse from '@student/components/Elements/CardCourse.vue';
import { sortArrayByProperty } from '@common/utils/Array/Array';
import { CoreStore } from '@student/modules/store';
import Auth from '@common/modules/auth';
import Api from '@student/modules/api/api';
import { computed, onMounted, ref, watch } from 'vue';
import EInput from '@common/ui/EInput.vue';
import { useMeta } from '@common/hooks/useMeta';
import { useI18n } from 'vue-i18n';
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';
import { useWindowSize } from '@vueuse/core';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SchoolCourses',
    setup: function (__props) {
        var t = useI18n().t;
        var searchQuery = ref('');
        var courses = ref([]);
        var loading = ref(false);
        var setTitle = useMeta().setTitle;
        var categoriesCache = {
            courses: null,
            searchQuery: null,
            result: null
        };
        var categories = computed(function () {
            var e_1, _a, e_2, _b, e_3, _c, e_4, _d, e_5, _e;
            var coursesValue = courses.value;
            var searchQueryValue = searchQuery.value;
            // Если данные не изменились, возвращаем кэшированный результат
            if (categoriesCache.result &&
                categoriesCache.courses === coursesValue &&
                categoriesCache.searchQuery === searchQueryValue) {
                return categoriesCache.result;
            }
            // Если данные изменились, выполняем вычисления
            var categoriesLocal = [];
            var categoryMap = new Map(); // Используем Map для быстрого поиска категорий
            try {
                // Первый проход - собираем все категории
                for (var coursesValue_1 = __values(coursesValue), coursesValue_1_1 = coursesValue_1.next(); !coursesValue_1_1.done; coursesValue_1_1 = coursesValue_1.next()) {
                    var course = coursesValue_1_1.value;
                    try {
                        for (var _f = (e_2 = void 0, __values(course.categories)), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var category = _g.value;
                            if (!categoryMap.has(category.id)) {
                                // Создаем копию категории с пустым массивом курсов
                                var categoryCopy = __assign(__assign({}, category), { courses: [], nameLower: category.name.toLowerCase() // Предварительно вычисляем для сортировки
                                 });
                                categoryMap.set(category.id, categoryCopy);
                                categoriesLocal.push(categoryCopy);
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (coursesValue_1_1 && !coursesValue_1_1.done && (_a = coursesValue_1.return)) _a.call(coursesValue_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            try {
                // Второй проход - добавляем курсы в соответствующие категории
                for (var coursesValue_2 = __values(coursesValue), coursesValue_2_1 = coursesValue_2.next(); !coursesValue_2_1.done; coursesValue_2_1 = coursesValue_2.next()) {
                    var course = coursesValue_2_1.value;
                    try {
                        for (var _h = (e_4 = void 0, __values(course.categories)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var category = _j.value;
                            var existCategory = categoryMap.get(category.id);
                            existCategory.courses.push(course);
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_j && !_j.done && (_d = _h.return)) _d.call(_h);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (coursesValue_2_1 && !coursesValue_2_1.done && (_c = coursesValue_2.return)) _c.call(coursesValue_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
            // Сортировка категорий - одна сортировка вместо двух
            categoriesLocal.sort(function (a, b) {
                // Сначала сортируем по order
                if (a.order !== b.order) {
                    return a.order - b.order;
                }
                // При одинаковом order сортируем по имени
                return a.nameLower.localeCompare(b.nameLower);
            });
            var _loop_1 = function (category) {
                category.courses = sortArrayByProperty(category.courses, function (course) {
                    return course.categoryOrders[category.id];
                });
            };
            try {
                // Сортируем курсы внутри категорий
                for (var categoriesLocal_1 = __values(categoriesLocal), categoriesLocal_1_1 = categoriesLocal_1.next(); !categoriesLocal_1_1.done; categoriesLocal_1_1 = categoriesLocal_1.next()) {
                    var category = categoriesLocal_1_1.value;
                    _loop_1(category);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (categoriesLocal_1_1 && !categoriesLocal_1_1.done && (_e = categoriesLocal_1.return)) _e.call(categoriesLocal_1);
                }
                finally { if (e_5) throw e_5.error; }
            }
            // Фильтрация по поисковому запросу
            var result = categoriesLocal;
            if (searchQueryValue !== '') {
                var query_1 = searchQueryValue.toLowerCase().replace(/\s+/g, '');
                result = categoriesLocal.filter(function (category) {
                    var categoryName = category.nameLower.replace(/\s+/g, '');
                    // Если совпадение по названию категории - отображаем со всеми курсами
                    if (categoryName.includes(query_1)) {
                        return true;
                    }
                    // Фильтруем курсы по поисковому запросу
                    category.courses = category.courses.filter(function (course) {
                        var courseName = course.name.toLowerCase().replace(/\s+/g, '');
                        return courseName.includes(query_1);
                    });
                    return category.courses.length > 0;
                });
            }
            // Обновляем кэш
            categoriesCache.courses = coursesValue;
            categoriesCache.searchQuery = searchQueryValue;
            categoriesCache.result = result;
            return result;
        });
        var coursesWithoutCategory = computed(function () {
            var query = searchQuery.value.toLowerCase().replace(/\s+/, '');
            var coursesLocal = courses.value.filter(function (course) {
                if (searchQuery.value !== '') {
                    var courseName = course.name.toLowerCase().replace(/\s+/, '');
                    // Если совпадение по названию курса - значит отображаем
                    if (!courseName.includes(query)) {
                        return false;
                    }
                }
                // Курс не принадлежит ни одной категории и не куплен пользователем
                return course.categories.length === 0;
            });
            // Сортируем курсы
            coursesLocal = sortArrayByProperty(coursesLocal, 'order', 'asc');
            return coursesLocal;
        });
        var myCourses = computed(function () {
            var query = searchQuery.value.toLowerCase().replace(/\s+/, '');
            var coursesLocal = courses.value.filter(function (course) {
                if (searchQuery.value !== '') {
                    var courseName = course.name.toLowerCase().replace(/\s+/, '');
                    // Если совпадение по названию категории - отображаем
                    var categoryMatch = course.categories.find(function (category) {
                        var categoryName = category.name.toLowerCase().replace(/\s+/, '');
                        return categoryName.includes(query);
                    });
                    // Если нет совпадений по навзанию или категориям - скрываем
                    if (!courseName.includes(query) && !categoryMatch) {
                        return false;
                    }
                }
                return course.allowed;
            });
            // Сортируем категории
            coursesLocal = sortArrayByProperty(coursesLocal, function (course) {
                return course.categories && course.categories.length > 0 ? (course.categories[0].order * 10) + course.categoryOrders[course.categories[0].id] : 100000 + course.order;
            }, 'asc');
            return coursesLocal;
        });
        var user = computed(function () { return Auth.getUser(); });
        var school = computed(function () { return CoreStore.school; });
        var getCourses = function () {
            loading.value = true;
            Api.getCourses().then(function (res) {
                var data = res.data;
                courses.value = data;
                loading.value = false;
            });
        };
        watch(user, function () {
            getCourses();
        });
        onMounted(function () {
            getCourses();
            setTitle(school.value.name);
        });
        var width = useWindowSize().width;
        // Определяем количество элементов в группе в зависимости от ширины экрана
        var getItemsPerRow = computed(function () {
            if (width.value < 640)
                return 1; // меньше sm - по 1
            if (width.value < 1120)
                return 2; // sm - по 2
            if (width.value < 1376)
                return 3; // lg - по 3
            return 4; // xl - по 4
        });
        var combinedCategoriesAndCourses = computed(function () {
            var e_6, _a;
            var result = [];
            try {
                // Добавляем категории с их курсами
                for (var _b = __values(categories.value), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var category = _c.value;
                    // Добавляем саму категорию
                    result.push({
                        id: "category-".concat(category.id),
                        type: 'category',
                        category: category
                    });
                    // Добавляем группы курсов для этой категории
                    var itemsPerRow = getItemsPerRow.value;
                    var coursesArray = __spreadArray([], __read(category.courses), false);
                    // Группируем курсы по количеству в строке
                    for (var i = 0; i < coursesArray.length; i += itemsPerRow) {
                        var group = coursesArray.slice(i, i + itemsPerRow);
                        result.push({
                            id: "category-".concat(category.id, "-group-").concat(i),
                            type: 'courses',
                            items: group,
                            category: category
                        });
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
            // Добавляем курсы без категории, если они есть
            if (coursesWithoutCategory.value.length > 0) {
                // Добавляем заголовок для курсов без категории
                if (categories.value.length > 0 || myCourses.value.length > 0) {
                    result.push({
                        id: 'no-category-header',
                        type: 'no-category-header'
                    });
                }
                // Группируем курсы без категории по количеству в строке
                var itemsPerRow = getItemsPerRow.value;
                for (var i = 0; i < coursesWithoutCategory.value.length; i += itemsPerRow) {
                    var group = coursesWithoutCategory.value.slice(i, i + itemsPerRow);
                    result.push({
                        id: "no-category-group-".concat(i),
                        type: 'courses-no-category',
                        items: group
                    });
                }
            }
            return result;
        });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _directive_loading = _resolveDirective("loading");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives((_openBlock(), _createBlock(EInput, {
                    modelValue: searchQuery.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((searchQuery).value = $event); }),
                    class: _normalizeClass([[
                            searchQuery.value === '' ? 'search-input--empty' : '',
                        ], "text-center search-input"]),
                    placeholder: _unref(t)('placeholders.searchCourses'),
                    theme: "gray",
                    clearable: ""
                }, {
                    prepend: _withCtx(function () { return [
                        _createVNode(_component_e_icon, {
                            class: "text-gray-300 w-5 h-5",
                            icon: "search"
                        })
                    ]; }),
                    _: 1
                }, 8, ["modelValue", "class", "placeholder"])), [
                    [_directive_loading, loading.value]
                ]),
                (combinedCategoriesAndCourses.value.length > 0 && !loading.value)
                    ? (_openBlock(), _createBlock(_unref(DynamicScroller), {
                        key: 0,
                        buffer: 600,
                        items: combinedCategoriesAndCourses.value,
                        "min-item-size": 70,
                        "page-mode": true,
                        class: "w-full page-scroller",
                        "key-field": "id"
                    }, {
                        default: _withCtx(function (_a) {
                            var item = _a.item, index = _a.index;
                            return [
                                (_openBlock(), _createBlock(_unref(DynamicScrollerItem), {
                                    key: item.id,
                                    active: true,
                                    index: index,
                                    item: item,
                                    "size-dependencies": [
                                        item.type === 'courses' || item.type === 'courses-no-category' ? item.items.length : 1,
                                        getItemsPerRow.value
                                    ],
                                    class: "w-full"
                                }, {
                                    default: _withCtx(function () { return [
                                        (item.type === 'category' && item.category.courses.length > 0)
                                            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                                                _createElementVNode("div", _hoisted_3, [
                                                    _createElementVNode("div", {
                                                        style: _normalizeStyle({ backgroundColor: item.category.color }),
                                                        class: "shrink-0 mr-3 w-4 h-4 rounded-full"
                                                    }, null, 4),
                                                    _createElementVNode("h2", _hoisted_4, _toDisplayString(item.category.name), 1)
                                                ])
                                            ]))
                                            : (item.type === 'courses')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                    _createElementVNode("div", _hoisted_6, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, function (course) {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: course.id,
                                                                class: "col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
                                                            }, [
                                                                _createVNode(cardCourse, {
                                                                    course: course,
                                                                    class: "h-full course-card"
                                                                }, null, 8, ["course"])
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ]))
                                                : (item.type === 'no-category-header')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                        _createElementVNode("h2", _hoisted_8, _toDisplayString(_unref(t)('titles.withoutCategory')), 1)
                                                    ]))
                                                    : (item.type === 'courses-no-category')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                            _createElementVNode("div", _hoisted_10, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, function (course) {
                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                        key: course.id,
                                                                        class: "col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
                                                                    }, [
                                                                        _createVNode(cardCourse, {
                                                                            course: course,
                                                                            class: "h-full course-card"
                                                                        }, null, 8, ["course"])
                                                                    ]));
                                                                }), 128))
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true)
                                    ]; }),
                                    _: 2
                                }, 1032, ["index", "item", "size-dependencies"]))
                            ];
                        }),
                        _: 1
                    }, 8, ["items"]))
                    : _createCommentVNode("", true),
                (courses.value.length === 0 && !loading.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(t)('messages.noCoursesAvailable')), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
